var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#svg_1b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6667,
    d: "M16.6628 2.5v3.3334m1.6667-1.6667h-3.3334m-11.6666 10v1.6667M4.1628 15H2.496m5.7809-2.0833a1.667 1.667 0 0 0-1.1975-1.1975L1.967 10.4009a.4167.4167 0 0 1 0-.8017L7.0795 8.28A1.667 1.667 0 0 0 8.277 7.0834l1.3183-5.1125a.4166.4166 0 0 1 .8025 0l1.3175 5.1125a1.667 1.667 0 0 0 1.1975 1.1975l5.1125 1.3175a.417.417 0 0 1 .2207.6541.417.417 0 0 1-.2207.1492l-5.1125 1.3175a1.667 1.667 0 0 0-1.1975 1.1975l-1.3183 5.1125a.4166.4166 0 0 1-.8025 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_1b",
    x1: 2.8878,
    x2: 24.4163,
    y1: 0.5628,
    y2: 17.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sparkle.1768f9249b1ef533599e2564fc09ad2a.svg";